import React from 'react'
import FooterLayout from './FooterLayout'

const LedgerVoucherFooter = (
    {
        isDisable,
        isSelectionEmpty,
        AddVchFunction,
        spaceFunction,
        duplicateFunction,
        insertFunction,
        deleteFunction,
        cancelFunction,
        removeLineFunction,
        restoreLineFunction,
        isDeleteDisabled,
        children
    }
) => {
    const fields = [
        { id: "1", name: "Back", shortcutKey: "Esc", type: 'button', line: '', isDisabled: false, state: '' },
        { id: "2", name: "View", shortcutKey: "Enter", type: 'button', line: '', isDisabled: false, state: '' },
        { id: "11", name: "Alter", shortcutKey: "Ctrl+Enter", type: 'button', line: '', isDisabled: false, state: '' },
        { id: "3", name: "Select", shortcutKey: "Space", type: 'button', line: '', isDisabled: false, state: () => spaceFunction() },
        { id: "4", name: "Add Vch", shortcutKey: "A", type: 'submit', line: 'single', isDisabled: false, state: () => AddVchFunction() },
        { id: "5", name: "Duplicate", shortcutKey: "2", type: 'button', line: 'single', isDisabled: isSelectionEmpty, state: () => duplicateFunction() },
        { id: "6", name: "Insert", shortcutKey: "I", type: 'button', line: 'single', isDisabled: true, state: () => insertFunction() },
        { id: "7", name: "Delete", shortcutKey: "D", type: 'button', line: 'single', isDisabled: isDeleteDisabled !== undefined ? isDeleteDisabled : isSelectionEmpty, state: () => deleteFunction() },
        { id: "8", name: "Cancel", shortcutKey: "X", type: 'button', line: 'single', isDisabled: true, state: () => cancelFunction() },
        { id: "9", name: "Remove Line", shortcutKey: "R", type: 'button', line: 'single', isDisabled: isSelectionEmpty, state: () => removeLineFunction() },
        { id: "10", name: "Restore Line", shortcutKey: "U", type: 'button', line: 'single', isDisabled: isDisable, state: () => restoreLineFunction() },
    ]
    return (
        <div className='tomasterfooter'>
            {children}
            <div className='footer'>
                {
                    fields.map((item, index) => {
                        return (
                            <FooterLayout key={item.id} fields={item} />
                        )
                    })
                }

            </div>
        </div>
    )
}

export default LedgerVoucherFooter
